import FormItem from '@/ui-kit/FormItem';
import TextInput from '@/ui-kit/TextInput';
import Icon from '@/ui-kit/Icon';

export default {
  components: {
    FormItem,
    TextInput,
    Icon,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    updateValue(field, value) {
      this.$emit('input', {
        ...this.value,
        [field]: value,
      });
    },
  },
}
